<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" ref="search" size="small">
        <el-form-item ref="query">
          <el-input placeholder="模板名称" v-model="queryprint.key"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getprintmodel">查询</el-button>
        </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
        <el-table :data="printmodel" v-loading="printLoading">
          <el-table-column prop="name" label="模板名称" width="900"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-edit"
                @click="getsettingprintmodels(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="queryprint.p"
            :page-sizes="[10, 20, 50]" :page-size="queryprint.rollpage" layout="total, sizes, prev, pager, next, jumper"
            :total="print_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!---------------------------编辑销售出库模板信息 start--------------------------------->
      <!---------------------------编辑销售出库模板信息 start--------------------------------->
      <!---------------------------编辑销售出库模板信息 start--------------------------------->
      <!---------------------------编辑销售出库模板信息 start--------------------------------->
      <!---------------------------编辑销售出库模板信息 start--------------------------------->
      <!---------------------------编辑销售出库模板信息 start--------------------------------->
      <el-dialog :title="`设置${editTitle}信息`" :visible.sync="editsellprintDialogs" width="85%" top="5vh">
        <template v-if="model_id == 1">
          <!---勾选信息---->
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.head" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.foot" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>

          <div style="float:left;width:100%;margin:50px 0 20px 0">
            <el-input placeholder="销售出库单" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:30%;margin-left:35%;text-align:center" align="center"
              v-if="item.id == 83 && item.isshow == true"></el-input>
            <el-input placeholder="设置每页显示条数" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:5%;float:right;text-align:center" align="center"
              v-if="item.id == 88 && item.isshow == true"></el-input>
          </div>
          <div style="width:100%">
            <span style="float:left;width:33.3%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id != 9 && item.isshow == true">{{ item.name }}</span>
            <span style="float:left;width:100%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id == 9 && item.isshow == true">{{ item.name }}</span>
          </div>
          <el-table :data="salelists" border style="margin-top:30px">
            <el-table-column v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
              :label="item.name" v-if="item.isshow == true" align="center"></el-table-column>
          </el-table>

          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id"
              v-if="(item.id == 10 || item.id == 11 || item.id == 12 || item.id == 13) && item.isshow == true">{{ item.name }}</span>
          </div>
          <div style="width:100%">
            <el-input type="textarea" :rows="1" placeholder="请输入内容" v-for="(item, index) in printeditlists.foot"
              :key="item.id" v-model="item.value" v-if="item.id == 14 && item.isshow == true"
              style="width:30%;margin:10px 0 10px 0"></el-input>
          </div>
          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id"
              v-if="(item.id == 15 || item.id == 16 || item.id == 87 || item.id == 136) && item.isshow == true">{{ item.name }}</span>
          </div>
        </template>

        <template v-if="model_id == 2">
          <!---勾选信息---->
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.head" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.foot" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>

          <div style="float:left;width:100%;margin:50px 0 20px 0">
            <el-input placeholder="进货入库单" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:30%;margin-left:35%;text-align:center" align="center"
              v-if="item.id == 84 && item.isshow == true"></el-input>
            <el-input placeholder="设置每页显示条数" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:5%;float:right;text-align:center" align="center"
              v-if="item.id == 89 && item.isshow == true"></el-input>
          </div>

          <div style="width:100%">
            <span style="float:left;width:33.3%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.isshow == true">{{ item.name }}</span>
          </div>
          <el-table :data="salelists" border style="margin-top:30px">
            <el-table-column v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
              :label="item.name" v-if="item.isshow == true" align="center"></el-table-column>
          </el-table>

          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id" v-if="(item.id == 33 || item.id == 34) && item.isshow == true">{{ item.name }}</span>
          </div>
        </template>

        <template v-if="model_id == 3">
          <!---勾选信息---->
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.head" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.foot" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>

          <div style="float:left;width:100%;margin:50px 0 20px 0">
            <el-input placeholder="进货入库单" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:30%;margin-left:35%;text-align:center" align="center"
              v-if="item.id == 85 && item.isshow == true"></el-input>
            <el-input placeholder="设置每页显示条数" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:5%;float:right;text-align:center" align="center"
              v-if="item.id == 90 && item.isshow == true"></el-input>
          </div>

          <div style="width:100%">
            <span style="float:left;width:33.3%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.isshow == true">{{ item.name }}</span>
          </div>
          <el-table :data="salelists" border style="margin-top:30px">
            <el-table-column v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
              :label="item.name" v-if="item.isshow == true" align="center"></el-table-column>
          </el-table>

          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id" v-if="(item.id == 47 || item.id == 48) && item.isshow == true">{{ item.name }}</span>
          </div>
        </template>

        <template v-if="model_id == 4">
          <!---勾选信息---->
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.head" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.foot" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>

          <div style="float:left;width:100%;margin:50px 0 20px 0">
            <el-input placeholder="线上商城销售出库单" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:30%;margin-left:35%;text-align:center" align="center"
              v-if="item.id == 86 && item.isshow == true"></el-input>
            <el-input placeholder="设置每页显示条数" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:5%;float:right;text-align:center" align="center"
              v-if="item.id == 90 && item.isshow == true"></el-input>
          </div>

          <div style="width:100%">
            <span style="float:left;width:33.3%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id != 63 && item.isshow == true">{{ item.name }}</span>
            <span style="float:left;width:100%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id == 63 && item.isshow == true">{{ item.name }}</span>
          </div>
          <el-table :data="salelists" border style="margin-top:30px">
            <el-table-column v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
              :label="item.name" v-if="item.isshow == true" align="center"></el-table-column>
          </el-table>

          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id"
              v-if="(item.id == 64 || item.id == 65 || item.id == 66 || item.id == 67) && item.isshow == true">{{ item.name }}</span>
          </div>
          <div style="width:100%">
            <el-input type="textarea" :rows="1" placeholder="请输入内容" v-for="(item, index) in printeditlists.foot"
              :key="item.id" v-model="item.value" v-if="item.id == 68 && item.isshow == true"
              style="width:30%;margin:10px 0 10px 0"></el-input>
          </div>
          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id" v-if="(item.id == 69 || item.id == 70) && item.isshow == true">{{ item.name }}</span>
          </div>
        </template>

        <template v-if="model_id == 5">
          <!---勾选信息---->
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.head" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.foot" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>

          <div style="float:left;width:100%;margin:50px 0 20px 0">
            <el-input placeholder="商品退货单" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:30%;margin-left:35%;text-align:center" align="center"
              v-if="item.id == 91 && item.isshow == true"></el-input>
            <el-input placeholder="设置每页显示条数" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:5%;float:right;text-align:center" align="center"
              v-if="item.id == 111 && item.isshow == true"></el-input>
          </div>

          <div style="width:100%">
            <span style="float:left;width:33.3%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id != 97 && item.isshow == true">{{ item.name }}</span>
            <span style="float:left;width:100%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id == 97 && item.isshow == true">{{ item.name }}</span>
          </div>
          <el-table :data="salelists" border style="margin-top:30px">
            <el-table-column v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
              :label="item.name" v-if="item.isshow == true" align="center"></el-table-column>
          </el-table>

          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id"
              v-if="(item.id == 108 || item.id == 109 || item.id == 110) && item.isshow == true">{{ item.name }}</span>
          </div>
        </template>
        <template v-if="model_id == 6">
          <!---勾选信息---->
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.head" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>
          <el-checkbox v-model="item.isshow" v-for="(item, index) in printeditlists.foot" :key="item.id"
            style="float:left;width:20%;margin-left:0;line-height:30px;">{{ item.name }}</el-checkbox>

          <div style="float:left;width:100%;margin:50px 0 20px 0">
            <el-input placeholder="商品采购单" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:30%;margin-left:35%;text-align:center" align="center"
              v-if="item.id == 112 && item.isshow == true"></el-input>
            <el-input placeholder="设置每页显示条数" size="22" v-model="item.value" v-for="(item, index) in printeditlists.foot"
              :key="item.id" style="width:5%;float:right;text-align:center" align="center"
              v-if="item.id == 113 && item.isshow == true"></el-input>
          </div>

          <div style="width:100%">
            <span style="float:left;width:33.3%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id != 132 && item.isshow == true">{{ item.name }}</span>
            <span style="float:left;width:100%;margin:2px 0 2px 0" v-for="(item, index) in printeditlists.head"
              :key="item.id" v-if="item.id == 132 && item.isshow == true">{{ item.name }}</span>
          </div>
          <el-table :data="salelists" border style="margin-top:30px">
            <el-table-column v-model="item.isshow" v-for="(item, index) in printeditlists.table" :key="item.id"
              :label="item.name" v-if="item.isshow == true" align="center"></el-table-column>
          </el-table>

          <div style="width:100%">
            <span style="float:left;width:25%;margin:10px 0 10px 0" v-for="(item, index) in printeditlists.foot"
              :key="item.id"
              v-if="(item.id == 126 || item.id == 127 || item.id == 128 || item.id == 129 || item.id == 130 || item.id == 131) && item.isshow == true">{{ item.name }}</span>
          </div>
        </template>

        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="editsellprintDialogs = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="epLoading" @click="editprintSave">保存</el-button>
        </div>
      </el-dialog>
      <!---------------------------编辑模板信息 end--------------------------------->

    </div>
  </transition>
</template>

<script>

export default {

  /** 数据 **/
  data() {
    return {
      url: this.GLOBAL.domain + "Setting/index",
      transitionshow: true,
      /** 模板列表信息 start **/
      queryprint: {
        act: 'printmodellists',
        token: this.$cookies.get('token'),
        key: '',
        p: 1,
        rollpage: 10,
      },
      printmodel: [],
      print_total_rows: 0,
      printLoading: false,
      /** 模板列表信息 end **/


      /** 获取单个模板信息 start **/
      editprintDialog: false,
      epLoading: false,
      printeditlists: [],
      model_id: '',
      /** 获取单个模板信息 end **/

      checked: false,
      editsellprintDialogs: false,
      salelists: [],
      editTitle: ''
    }
  },


  /** 预加载项 **/
  mounted() {
    /** 获取打印设置模本列表 **/
    this.getprintmodel();
  },


  methods: {

    pageSizeChange(val) {
      this.queryprint.rollpage = val;
      this.getprintmodel();
    },

    pageCurrentChange(val) {
      this.queryprint.p = val;
      this.getprintmodel();
    },


    /** 获取打印设置模板列表 **/
    getprintmodel() {
      this.printLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.queryprint).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
          this.printLoading = false;
        } else {
          this.printmodel = JSON.parse(Base64.decode(res.data.Data));
          this.print_total_rows = parseInt(res.data.count);
          this.printLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.printLoading = false;
      });
    },
    /** 获取模板信息设置 **/
    getsettingprintmodels(obj) {
      var resource = this.$resource(this.url);
      this.model_id = obj.id;
      this.editTitle = obj.name
      resource.query({ act: 'getprintmodel', id: obj.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.printeditlists = JSON.parse(Base64.decode(res.data.Data));
          console.log(this.printeditlists, 'GGGGGGGGGGGGGGGGGGGGGG');
          this.editsellprintDialogs = true; //销售出库模板
          this.checked = true;

        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },



    /** 保存修改的模板设置 **/
    editprintSave() {
      this.epLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'saveprintmodel', id: this.model_id, model: this.printeditlists, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.epLoading = false;
          this.editsellprintDialogs = false;
          this.$message.success("模板设置成功！");
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}
</style>


// WEBPACK FOOTER //
// src/components/config/Print.vue